export default "__VITE_ASSET__BhNrfsct__"